import React from "react";
import { Button, Empty, Space, Switch } from "antd";
import confirmBox from "../../CoreComponents/confirmBox";
import { deleteBanner, reorderStrip, updateBanner } from "./api";
import { HiddenTag, ListRow, linkLabel } from "./bannerTags";
import { notify } from "./notify";

export default function StripList({ banners, onChanged, onEdit, placement, franchiseId }) {
  const move = async (index, step) => {
    const ids = banners.map((b) => b.id);
    [ids[index], ids[index + step]] = [ids[index + step], ids[index]];
    if (notify(await reorderStrip(placement, ids, franchiseId))) onChanged();
  };
  const toggle = async (banner, on) => {
    if (notify(await updateBanner(banner.id, { isActive: on }), on ? "Banner on" : "Banner off")) onChanged();
  };
  const remove = (banner) =>
    confirmBox({
      title: "Delete this banner?",
      yesLabel: "Delete",
      onYes: async () => notify(await deleteBanner(banner.id), "Banner deleted") && onChanged(),
    });
  if (!banners.length) return <Empty description="No banners yet" />;
  return banners.map((banner, index) => (
    <ListRow key={banner.id}>
      <img src={banner.image} alt="" style={{ width: 160, aspectRatio: "2 / 1", objectFit: "cover", borderRadius: 8 }} />
      <div style={{ flex: 1, minWidth: 160 }}>{linkLabel(banner)}</div>
      <HiddenTag reason={banner.hidden_now} />
      <Switch checked={banner.is_active} onChange={(on) => toggle(banner, on)} />
      <Space>
        <Button disabled={index === 0} onClick={() => move(index, -1)}>Up</Button>
        <Button disabled={index === banners.length - 1} onClick={() => move(index, 1)}>Down</Button>
        <Button onClick={() => onEdit(banner)}>Edit</Button>
        <Button danger onClick={() => remove(banner)}>Delete</Button>
      </Space>
    </ListRow>
  ));
}
